export default __webpack_public_path__ + "static/media/card-image6.0f22b8e3.png";